import {useTranslation} from 'next-i18next'
import AppDivider from 'src/components/elements/AppDivider'
import AppTypography from 'src/components/elements/typography/AppTypography'
import AppModal from 'src/components/elements/AppModal'
import {AmenitySection, AmenityFeatureType} from 'src/types/amenities'
import AmenityFeatureRow from 'src/components/modules/listingStepOne/amenities/AmenityFeatureRow'
import {Fragment} from 'react'

export default function AllAmenitiesModal(props: {
  visible: boolean
  amenitySections: AmenitySection[]
  handleClose: () => void
}) {
  const {visible, handleClose, amenitySections} = props
  const {t} = useTranslation(['common', 'amenity'])

  return (
    <AppModal title={t('amenities')} open={visible} onClose={handleClose}>
      <div>
        {amenitySections.map((section: AmenitySection, idx: number) => (
          <Fragment key={idx}>
            <div className="py-6">
              <AppTypography
                className="pb-4"
                neutralColor={800}
                variant="headingSlim"
              >
                {t(section.title, {ns: 'amenity'})}
              </AppTypography>
              <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
                {section.features.map((amenity: AmenityFeatureType) => (
                  <AmenityFeatureRow
                    key={amenity.label}
                    amenity={amenity}
                    isAction={false}
                  />
                ))}
              </div>
            </div>
            <AppDivider />
          </Fragment>
        ))}
      </div>
    </AppModal>
  )
}
